import toast from "react-hot-toast";
import { formataDate } from "./datas";

function extraiNumeroMeta(metrica) {
    let metaNumerico = metrica.match(/[\d]+/);
    return metaNumerico = parseInt(metaNumerico[0], 10)
}

function filtraMetricaId(array, metricaId) {
    // Recebe um array como parametro e uma metricaId a ser procurada
    // Tenha certeza de que o array comparado tenha o metricaID e o metricaID esteja sendo passado corretamente
    const filteredData = array.filter(item => item.metricaId === metricaId);
    return filteredData
}

function filtraMesMetrica(array, mes) {
    // Recebe um array como parametro e uma metricaId a ser procurada
    // Tenha certeza de que o array comparado tenha o metricaID e o metricaID esteja sendo passado corretamente
    const filteredData = array.filter(item => item.mes === mes);
    return filteredData
}

function preencherDadosFaltantesParaGraficos(series) {
    /**
     * O HeatMap não lida bem com ausência de dados entre as colunas,
     * por isso tive que criar essa função pra preencher possiveis lacunas
    */

    const todosOsX = new Set();

    series.forEach(s => {
        s.data.forEach(d => {
            todosOsX.add(d.x)
        });
    });

    // Criar uma nova versão dos dados com os valores ausentes preenchidos
    return series.map(s => ({
        name: s.name,
        data: Array.from(todosOsX).sort((a, b) => a - b).map(x => {
            const encontrado = s.data.find(d => d.x === x);
            return { x, y: encontrado ? encontrado.y : 0 }; // Usa 0 para preencher
        })
    }));
}

// const transformaDadosParaGraficoHeatMap = (listaDadosGrafico) => {
//     /**
//      * O HeatMap usa um formato específico de dados, daí pra não retornar um dado sem sentido pela API, achei melhor
//      * criar uma função que faça essa transformação antes de passar os dados pro componente.
//     */

//     // let seriesFormatHeatMap = []
//     return listaDadosGrafico.forEach(metrica => {
//         seriesFormatHeatMap.push({
//             name: `Indicador ${metrica.codigo}`,
//             data: metrica.indicadores.map(dadosDoMes => ({
//                 x: dadosDoMes.mesReferencia,  // Transforma "mesReferencia" em "x"
//                 y: dadosDoMes.percentAlcancado // Transforma "percentAlcancado" em "y"
//             }))
//         })
//     });
//     // return seriesFormatHeatMap
// }

/**
 * O HeatMap usa um formato específico de dados, daí pra não retornar um dado sem sentido pela API, achei melhor
 * criar uma função que faça essa transformação antes de passar os dados pro componente.
 * @param {Array} listaDadosGrafico - Lista bruta vinda do banco/service.
 * @returns {Array} Array de objetos formatados com { name, data: [{ x, y }] }.
*/
const formatarDadosParaHeatMap = (listaDadosGrafico) => {
    return listaDadosGrafico.map(metrica => ({
        name: `Indicador ${metrica.codigo}`,
        data: metrica.indicadores.map(dadosDoMes => ({
            x: dadosDoMes.mesReferencia,
            y: dadosDoMes.percentAlcancado
        }))
    }));
};

function formataOperadoresRelacionaisMetrica(meta) {

    const operadores = {
        '>=': '≥',
        '<=': '≤',
        '==': '=',
    };

    const regex = /(>=|<=|==)(.*)/;
    const match = meta.match(regex);

    if (!match) {
        return meta;
    }

    const operadorEncontrado = match[1];
    const valor = match[2];

    // Pega o símbolo correspondente do objeto de mapeamento
    const simboloFormatado = operadores[operadorEncontrado];

    // Concatena o símbolo formatado com o valor
    return `${simboloFormatado} ${valor}`;
}

function formatCPF(raw) {
    if (!raw && raw !== 0) return '';
    const s = String(raw).replace(/\D/g, '');         // só dígitos
    if (s.length !== 11) return raw;                  // se não tem 11 dígitos, retorna como veio (ou '' se preferir)
    return s.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

function toastErrorFromResponse(error) {
    console.error(error);
    toast.error(error.response?.data?.message || 'Erro inesperado');
}

const primeiraLetraMaiuscula = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

export {
    extraiNumeroMeta,
    filtraMetricaId,
    filtraMesMetrica,
    formatarDadosParaHeatMap,
    preencherDadosFaltantesParaGraficos,
    formataOperadoresRelacionaisMetrica,
    formatCPF,
    toastErrorFromResponse,
    primeiraLetraMaiuscula
}